import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_authorized/team/settings")({
	component: () => <Outlet />,
});
